var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.242,
    height: 69.242,
    viewBox: "0 0 69.242 69.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support_Request",
    "data-name": "Support Request",
    transform: "translate(8.571 9.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(-8.571 -9.775)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.242,
    height: 69.242,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 66.242,
    height: 66.242,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M36.415,43.055H28.448a9.63,9.63,0,0,1-.32-2.285.761.761,0,0,0-.358-.647.751.751,0,0,0-.739-.03,3.581,3.581,0,0,0-2.315,2.963H20.908A3.064,3.064,0,0,0,18,46.254v7.312a3.064,3.064,0,0,0,2.909,3.2H36.415a3.064,3.064,0,0,0,2.909-3.2V46.254A3.064,3.064,0,0,0,36.415,43.055ZM32.47,52.194H24.854a.762.762,0,1,1,0-1.523H32.47a.762.762,0,1,1,0,1.523Zm2.285-3.046H22.569a.762.762,0,1,1,0-1.523H34.755a.762.762,0,1,1,0,1.523Z",
    transform: "translate(-2.612 -9.063)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M29.378,28.777A8.383,8.383,0,0,0,37.756,20.4C37.3,9.288,21.457,9.288,21,20.4a8.383,8.383,0,0,0,8.378,8.378Z",
    transform: "translate(-3.328 -2.401)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M41.282,13.5a2.294,2.294,0,0,0-2.407-2.353A10.749,10.749,0,0,0,28.335,2c-1.691.053-5.43-.183-7.022.3a10.685,10.685,0,0,0-8.081,8.842A2.3,2.3,0,0,0,10.817,13.5a4.57,4.57,0,0,0,0,9A2.292,2.292,0,0,0,13.1,24.853h1.523a2.292,2.292,0,0,0,2.285-2.285V13.428a2.278,2.278,0,0,0-2.148-2.27,9.166,9.166,0,0,1,6.009-7.114,3.044,3.044,0,0,0,2.993,2.529h4.57a3.044,3.044,0,0,0,2.993-2.529,9.188,9.188,0,0,1,6.017,7.114,2.28,2.28,0,0,0-2.155,2.27v9.139a2.255,2.255,0,0,0,.64,1.577,8.882,8.882,0,0,1-6.192,4.318,2.281,2.281,0,1,0,.145,1.523,10.4,10.4,0,0,0,7.411-5.164c.16.053,1.607.023,1.805.03A2.292,2.292,0,0,0,41.282,22.5a4.57,4.57,0,0,0,0-9ZM10.817,20.946a3.051,3.051,0,0,1,0-5.895Zm15.994,8.477a.762.762,0,1,1,.758.766.762.762,0,0,1-.758-.766Zm14.471-8.477V15.051a3.051,3.051,0,0,1,0,5.9Z",
    transform: "translate(0)",
    fill: "#00b26b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.ca2107dc9adf4462a799759c3b080ad3.svg";
export { ForwardRef as ReactComponent };